import React from 'react';
import {
  FiArrowUpRight,
  FiBriefcase,
  FiCpu,
  FiGlobe,
  FiMail,
  FiMic,
  FiPlayCircle,
} from 'react-icons/fi';
import { FaLinkedinIn } from 'react-icons/fa6';
import { SiFacebook, SiInstagram, SiYoutube } from 'react-icons/si';
import hrdBadge from '../../assets/hrd-corp-accredited-trainer.png';

const workLinks = [
  { label: 'Training & Speaking', href: '#training', Icon: FiMic },
  { label: 'AI Consulting', href: '#consulting', Icon: FiCpu },
  { label: 'Videos & Learning', href: '#media', Icon: FiPlayCircle },
  { label: 'Companies & projects', href: '#worked-with', Icon: FiBriefcase },
];

const companyLinks = [
  { label: 'Botsify', href: 'https://botsify.com' },
  { label: 'ReachOwl', href: 'https://reachowl.com' },
  { label: 'Dotomat', href: 'https://dotomat.com' },
  { label: 'ScreenWith.me', href: 'https://screenwith.me' },
];

const connectLinks = [
  { label: 'Email', href: 'mailto:usama@botsify.com', Icon: FiMail },
  { label: 'LinkedIn', href: 'https://uk.linkedin.com/in/usamanoman', Icon: FaLinkedinIn },
  { label: 'YouTube', href: 'https://www.youtube.com/@botsify', Icon: SiYoutube },
  { label: 'Facebook', href: 'https://web.facebook.com/usamathefounder', Icon: SiFacebook },
  { label: 'Instagram', href: 'https://www.instagram.com/usamathefounder/', Icon: SiInstagram },
];

const ext = (href) => (href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {});

export default function Footer({ track = 'teach' }) {
  return (
    <footer className="tt-footer">
      <div className="tt-wrap">
        <div className="tt-footer-grid">
          <div>
            <p className="tt-footer-name">Usama Noman</p>
            <p className="tt-footer-role">
              {track === 'teach'
                ? 'HRD Corp Accredited Trainer · Founder · AI consultant'
                : 'Founder · AI consultant · HRD Corp Accredited Trainer'}
            </p>
            <div className="tt-footer-socials" aria-label="Social links">
              {connectLinks.map(({ label, href, Icon }) => (
                <a key={label} href={href} aria-label={label} className="tt-footer-social-icon" {...ext(href)}>
                  <Icon aria-hidden="true" />
                </a>
              ))}
            </div>
            <div className="tt-footer-hrd">
              <img
                src={hrdBadge}
                alt="HRD Corp Accredited Trainer"
                className="tt-footer-hrd-seal"
                loading="lazy"
              />
              <div className="tt-footer-hrd-text">
                <strong>HRD Corp Accredited Trainer</strong>
                <span>Trainer ID: 72369</span>
              </div>
            </div>
          </div>
          <div>
            <h4>Work with me</h4>
            <ul>
              {workLinks.map(({ label, href, Icon }) => (
                <li key={label}>
                  <a href={href} className="tt-footer-link">
                    <Icon className="tt-footer-link-icon" aria-hidden="true" />
                    <span>{label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4>Companies</h4>
            <ul>
              {companyLinks.map(({ label, href }) => (
                <li key={label}>
                  <a href={href} className="tt-footer-link" {...ext(href)}>
                    <FiGlobe className="tt-footer-link-icon" aria-hidden="true" />
                    <span>{label}</span>
                    <FiArrowUpRight className="tt-footer-ext-icon" aria-hidden="true" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4>Connect</h4>
            <ul>
              {connectLinks.map(({ label, href, Icon }) => (
                <li key={label}>
                  <a href={href} className="tt-footer-link" {...ext(href)}>
                    <Icon className="tt-footer-link-icon" aria-hidden="true" />
                    <span>{label}</span>
                    {href.startsWith('http') && (
                      <FiArrowUpRight className="tt-footer-ext-icon" aria-hidden="true" />
                    )}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="tt-footer-bottom">
          <span>© Usama Noman 2026. All rights reserved.</span>
          <span>Privacy Policy · Terms of Service</span>
        </div>
      </div>
    </footer>
  );
}
